import DeleteIcon from "@mui/icons-material/Delete";
import {
  Autocomplete,
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Select,
  Stack,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import { visuallyHidden } from "@mui/utils";
import { format } from "date-fns";
import PropTypes from "prop-types";
import * as React from "react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  retrieveFastOrdersApi,
  retrieveOrderByIdApi,
} from "../../../components/api/OrderApiService";
import {
  approveShipmentRequestApi,
  createShipmentRequestApi,
  retrieveAllShipmentRequestsApi,
  retrieveFastFilteredShipmentRequestsApi,
  retrieveFastShipmentRequestsApi,
  retrieveFilteredShipmentRequestsApi,
  retrieveShipmentRequestByIdApi,
} from "../../../components/api/ShipmentRequestApiService";
import { retrieveFastStakeholdersApi } from "../../../components/api/StakeholderApiService";
import ExportExcel from "../../../utils/excelExport";
import EditCustomerOrder from "../CustomerOrder/EditCustomerOrder";
import CreateSI from "../ShippingInstructionView/AddShippingInstruction";
import EditVendorOrder from "../VendorOrderView/EditVendorOrder";
import AddShipmentRequest from "./AddShipmentRequest";
import EditShipmentRequest from "./EditShipmentRequest";
import { retrieveUsersApi } from "../../../components/api/UserApiService";
import { retrieveAllWarehouseApi } from "../../../components/api/WarehouseApiService";
import ItemButton from "./Dialogs/ItemButton";
import OrderButton from "./Dialogs/OrderButton";
import EditItem from "../ItemView/EditItem";
import { retrieveAllItemsApi } from "../../../components/api/ItemApiService";
import { deleteUserComponentSettingsApi, retrieveUserComponentSettingsApi, retrieveUserReportsApi, saveUserComponentSettingsApi } from "../../../components/api/UserComponentSettingsApiService";
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  SortableContext,
  useSortable,
  arrayMove,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import SortableItem from "../ShippingInstructionView/Dialogs/SortableItem";
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from "@mui/icons-material/Add";
import { retrieveQuantityByItemIdApi } from "../../../components/api/QuantityApiService";
import { ClipLoader } from "react-spinners";
import FilterSelect from "../../../components/FilterSelect";
import { useAuth } from "../../../auth/AuthContext";
import MyFilters from "../../../components/MyFilters";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "editButton",
    disablePadding: true,
    label: "",
       render: (row, rowIndex, { setEditShipmentRequest }) => (
        <Button
        onClick={(e) => {
          if (!row?.id) {
            alert("Please refresh the page.");
            return;
          }
          e.preventDefault();
          if (row?.status === "SI Created") {
            alert("An SI is connected to this SR. Editing is not allowed.");
             return;
          } else if (row?.status === "SI Closed") {
            alert(
              "An SI connected to this SR is closed. Editing is not allowed.",
            );
            return;
          }
          setEditShipmentRequest({
            visible: true,
            data: row,
            index: rowIndex,
          });
        }}
      >
        Edit
      </Button>
        ),
  },
  {
    id: "approveButton",
    disablePadding: true,
    label: "",
    render: (row, rowIndex, { retrieveUsers, openAssignUserDialog, closeAssignUserDialog, isAssignUserDialogOpen, selectedUser, setSelectedUser, users, handleAssignAndApprove }) => (
      <>
      <Button
               variant="outlined"
               disabled={row?.approvalStatus === "Approved"}
               onMouseDown={retrieveUsers}
               onClick={() => {
                 if (!row?.id) {
                   alert("Please refresh the page.");
                   return;
                 }
                 retrieveShipmentRequestByIdApi(row?.id)
                 .then((response) => {
                  console.error("ok", response?.data);
                   openAssignUserDialog(response?.data)
                 })
                 .catch((error) => {
                   console.error("Error fetching shipment request data:", error);
                   toast.error("Failed to retrieve shipment request details. Please try again later.");
                 });
                 }
               }
             >
               Approve
             </Button>
                     <Dialog
                     open={isAssignUserDialogOpen}
                     onClose={closeAssignUserDialog}
                   >
                     <DialogTitle>
                       Assign Shipment Request to a User
                     </DialogTitle>
                     <DialogContent>
                       <Select
                         value={selectedUser}
                         onChange={(e) =>
                           setSelectedUser(e.target.value)
                         }
                         displayEmpty
                         fullWidth
                       >
                         <MenuItem value="" disabled>
                           Select a User
                         </MenuItem>
                         {users.map((user) => (
                           <MenuItem key={user} value={user}>
                             {user.name}
                           </MenuItem>
                         ))}
                       </Select>
                     </DialogContent>
                     <DialogActions>
                       <Button onClick={closeAssignUserDialog}>
                         Cancel
                       </Button>
                       <Button
                         onClick={handleAssignAndApprove}
                         disabled={!selectedUser}
                       >
                         Approve
                       </Button>
                     </DialogActions>
                   </Dialog>
                   </>
      ),
  },
  {
    id: "createSIButton",
    disablePadding: true,
    label: "",
    render: (row, rowIndex, { setShowSIPopup}) => (
      <Button
      style={{ width: "max-content" }}
      disabled={
        row?.approvalStatus !== "Approved" ||
        row?.status === "SI Created" ||
        row?.status === "SI Closed"
      }
      onClick={() => {
        /*if (
          localStorage.getItem("username") ===
          row?.assignedUserEmail
        ) { */
          retrieveShipmentRequestByIdApi(row?.id)
          .then((response) => {
            setShowSIPopup({ data: response?.data, visible: true });
          })
          .catch((error) => {
            console.error("Error fetching shipment request data:", error);
            toast.error("Failed to retrieve shipment request details. Please try again later.");
          });
      /*}else {
          toast.error(
            "You are not the assigned user for this SI.",
          );
        }*/
      }}
    >
      Create SI
    </Button>
      ),
  },
  {
    id: "duplicateButton",
    disablePadding: true,
    label: "",
    render: (row, rowIndex, {handleDuplicate, loadingRecord}) => 
     loadingRecord === row?.id ? (
             <ClipLoader color="#000000" loadingRecord={loadingRecord} size={35} />
           ) : (
      <Button
      variant="outlined"
      onClick={() => {
        if (!row?.id) {
          alert("Please refresh the page.");
          return;
        }
        retrieveShipmentRequestByIdApi(row?.id)
        .then((response) => {
          handleDuplicate(response?.data)
        })
        .catch((error) => {
          window.alert("Failed to retrieve shipment request. Please try again later.");
        });}
      }
    >
      Duplicate
    </Button>
      ),
  },
  {
    id: "id",
    numeric: true,
    disablePadding: true,
    label: "ID",
    render: (row) => row?.id,
  },
  {
    id: "assignedUserName",
    numeric: true,
    disablePadding: true,
    label: "Assigned To",
    render: (row) => row?.assignedUserName,
  },
  {
    id: "shipmentRequestType",
    numeric: false,
    disablePadding: true,
    label: "Type",
    render: (row) => row?.shipmentRequestType,
  },
  {
    id: "shipmentQuantity",
    numeric: true,
    disablePadding: true,
    label: "Shipment Quantity",
    render: (row) =>
          row?.shipmentQuantity
            ? `${new Intl.NumberFormat("en-US", { style: "decimal", minimumFractionDigits: 2 }).format(row.shipmentQuantity)} ${row?.shipmentQuantityUnit || ""}`
            : "",
  },
  {
    id: "shipmentRequestTo",
    numeric: false,
    disablePadding: true,
    label: "SR To",
    render: (row) => row?.shipmentRequestTo,
  },
  {
    id: "purchaseOrderId",
    numeric: false,
    disablePadding: true,
    label: "PO Id",
    render: (row, rowIndex, { setEditVendorOrder }) => (
          <OrderButton
            row={row}
            id={row?.purchaseOrderId}
            setEditOrder={setEditVendorOrder}
          />
        ),
  },
  {
    id: "purchaseOrderCompany",
    disablePadding: true,
    label: "PO Company",
    render: (row) => row?.purchaseOrderCompany,
  },
  {
    id: "purchaseOrderNumber",
    numeric: false,
    disablePadding: true,
    label: "SAP PO Number",
    render: (row) => row?.purchaseOrderNumber,
  },
  {
    id: "purchaseOrderVolume",
    disablePadding: true,
    label: "PO Quantity",
    render: (row) =>
      row?.purchaseOrderVolume
        ? `${new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
          }).format(row?.purchaseOrderVolume)} ${
            row?.purchaseOrderVolumeUnit
          }`
        : "",
  },
  {
    id: "purchaseOrderStakeholderName",
    numeric: false,
    disablePadding: true,
    label: "Supplier",
    render: (row) => row?.purchaseOrderStakeholderName,
  },
  {
    id: "itemId",
    numeric: false,
    disablePadding: true,
    label: "Item ID",
     render: (row, rowIndex, { setEditItem }) => (
          <ItemButton
            row={row}
            id={row?.salesOrderItemId || row?.purchaseOrderItemId || ""}
            setEditItem={setEditItem}
          />
        ),
  },
  {
    id: "origin",
    numeric: false,
    disablePadding: true,
    label: "Origin",
    render: (row) =>
      row?.salesOrderItemOrigin || row?.purchaseOrderItemOrigin || "",
  },
  {
    id: "type",
    numeric: false,
    disablePadding: false,
    label: "Type",
    render: (row) =>
      row?.salesOrderItemType || row?.purchaseOrderItemType || "",
  },
  {
    id: "buyingGrade",
    numeric: false,
    disablePadding: true,
    label: "Buying Grade",
    render: (row) =>
      row?.salesOrderItemBuyingGrade || row?.purchaseOrderItemBuyingGrade || "",
  },
  {
    id: "salesOrderSalesGrade",
    numeric: false,
    disablePadding: true,
    label: "Sales Grade",
    render: (row) => row?.salesOrderSalesGrade,
  },
  {
    id: "crop",
    numeric: true,
    disablePadding: true,
    label: "Crop Year",
    render: (row) =>
      row?.salesOrderItemCrop || row?.purchaseOrderItemCrop || "",
  },
  {
    id: "salesOrderDescriptionOfGoods",
    numeric: true,
    disablePadding: true,
    label: "Description Of Goods",
    render: (row) => (
      row?.salesOrderDescriptionOfGoods?.length >
      50 ? (
        <span
          style={{
            display: "inline-block",
            maxWidth: "350px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            verticalAlign: "top",
          }}
          title={row?.salesOrderDescriptionOfGoods}
        >
          {row?.salesOrderDescriptionOfGoods}
        </span>
      ) : (
        row?.salesOrderDescriptionOfGoods
      )
    ),
  },
  {
    id: "storage",
    numeric: true,
    disablePadding: true,
    label: "Current Location",
    render: (row) =>
      row?.salesOrderItemStorage || row?.purchaseOrderItemStorage || "",
  },
  {
    id: "salesOrderSecondSampleStatus",
    numeric: false,
    disablePadding: true,
    label: "Redrawn Status",
    render: (row) => row?.salesOrderSecondSampleStatus,
  },
  {
    id: "salesOrderId",
    numeric: true,
    disablePadding: true,
    label: "SO Id",
    render: (row, rowIndex, { setEditCustomerOrder }) => (
      <OrderButton
        row={row}
        id={row?.salesOrderId}
        setEditOrder={setEditCustomerOrder}
      />
    ),
  },
  {
    id: "salesOrderNumber",
    disablePadding: true,
    label: "SAP SO Number",
    render: (row) => row?.salesOrderNumber,
  },
  {
    id: "salesOrderCompany",
    disablePadding: true,
    label: "SO Company",
    render: (row) => row?.salesOrderCompany,
  },
  {
    id: "salesOrderStakeholderName",
    numeric: false,
    disablePadding: true,
    label: "Customer",
    render: (row) => row?.salesOrderStakeholderName,
  },
  {
    id: "customerGradeMark",
    numeric: false,
    disablePadding: true,
    label: "Customer Grade Mark",
    render: (row) => row?.customerGradeMark,
  },
  {
    id: "warehouse",
    numeric: false,
    disablePadding: true,
    label: "Warehouse",
    render: (row) => row?.warehouse,
  },
  {
    id: "destination",
    numeric: false,
    disablePadding: true,
    label: "Destination",
    render: (row) => row?.destination,
  },
  {
    id: "portOfLoading",
    numeric: false,
    disablePadding: true,
    label: "Port Of Loading",
    render: (row) => row?.portOfLoading,
  },
  {
    id: "portOfDischarge",
    numeric: false,
    disablePadding: true,
    label: "Port Of Discharge",
    render: (row) => row?.portOfDischarge,
  },
  {
    id: "numberOfCases",
    numeric: true,
    disablePadding: true,
    label: "Number Of Cartons",
    render: (row) => row?.numberOfCases,
  },
  {
    id: "netWeightPerCase",
    numeric: true,
    disablePadding: true,
    label: "Net Weight Per Carton",
    render: (row) => row?.netWeightPerCase,
  },
  {
    id: "cartonsPerContainer",
    numeric: false,
    disablePadding: true,
    label: "Cartons Per Container",
    render: (row) => row?.cartonsPerContainer,
  },
  {
    id: "shipmentEstimatedTimeOfDeparture",
    numeric: false,
    disablePadding: true,
    label: "Shipment ETD",
    render: (row) => (
      row?.shipmentEstimatedTimeOfDeparture
        ? format(
            new Date(
              row?.shipmentEstimatedTimeOfDeparture,
            ),
            "dd/MM/yyyy",
          )
        : ""
    ),
  },
  {
    id: "approvalStatus",
    numeric: false,
    disablePadding: true,
    label: "Approval Status",
    render: (row) => row?.approvalStatus,
  },
  {
    id: "approvalDate",
    numeric: false,
    disablePadding: true,
    label: "Approval Date",
    render: (row) => (
      row?.approvalDate
        ? format(
            new Date(
              row?.approvalDate,
            ),
            "dd/MM/yyyy",
          )
        : ""
    ),
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Status",
    render: (row) => row?.status,
  },
  {
    id: "loadingRemark",
    numeric: false,
    disablePadding: true,
    label: "Loading Remark",
    render: (row) => (
      row?.loadingRemark?.length >
      50 ? (
        <span
          style={{
            display: "inline-block",
            maxWidth: "350px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            verticalAlign: "top",
          }}
          title={row?.loadingRemark}
        >
          {row?.loadingRemark}
        </span>
      ) : (
        row?.loadingRemark
      )
    ),
  },
  {
    id: "remark",
    numeric: false,
    disablePadding: true,
    label: "Remark",
    render: (row) => row?.remark,
  },
  {
    id: "referenceShippingInstruction",
    numeric: false,
    disablePadding: true,
    label: "Reference SI",
    render: (row) =>
      `${row?.referenceShippingInstructionId || ""}-${row?.referenceShippingInstructionNumber || ""}`,
  },
  {
    id: "timestamp",
    numeric: false,
    disablePadding: true,
    label: "Creation Time",
    render: (row) => (
      row?.timestamp
        ? format(
            new Date(row.timestamp),
            "dd/MM/yyyy HH:mm",
          )
        : ""
    ),
  },
  {
    id: "creator",
    numeric: false,
    disablePadding: true,
    label: "Created By",
    render: (row) => row?.creator,
  },
  {
    id: "recordStatus",
    numeric: false,
    disablePadding: false,
    label: "Record Status",
    render: (row) => row?.recordStatus,
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    visibleColumns = headCells.map(cell => cell.id),
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all",
            }}
          />
        </TableCell>
        {headCells.filter(headCell => visibleColumns.includes(headCell.id))
           .sort((a, b) => visibleColumns.indexOf(a.id) - visibleColumns.indexOf(b.id))
           .map(headCell => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function ShipmentRequestTable({
  visibleRows,
  dense,
  isSelected,
  handleClick,
  emptyRows,
  visibleColumns,
  onSelectAllClick,
  order,
  orderBy,
  numSelected,
  rowCount,
  onRequestSort,
  // extra functions for custom cell renders
  setEditShipmentRequest,
  retrieveUsers,
  openAssignUserDialog,
  closeAssignUserDialog, 
  isAssignUserDialogOpen, 
  selectedUser, 
  setSelectedUser, 
  users, 
  handleAssignAndApprove,
  handleDuplicate,
  setShowSIPopup,
  retrieveShipmentRequestByIdApi,
  retrieveFilteredShipmentRequestsApi,
  setEditItem,
  setEditVendorOrder,
  setEditCustomerOrder,
  loadingRecord,
}) {
  const activeHeadCells = headCells
    .filter((cell) => visibleColumns.includes(cell.id))
    .sort((a, b) => visibleColumns.indexOf(a.id) - visibleColumns.indexOf(b.id));

  return (
    <TableContainer style={{ maxHeight: 700 }}>
    <Table
                  stickyHeader
                  aria-label="sticky table"
                  sx={{
                    minWidth: 750,
                    "& .MuiTableCell-root": {
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                    },
                    "& .MuiTableCell-head": {
                      backgroundColor: "#20315d",
                      color: "white",
                      borderRight: "1px solid rgba(49, 64, 128, 1)",
                    },
                  }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  style={{ width: "max-content" }}
                >
        <EnhancedTableHead
          numSelected={numSelected}
          order={order}
          orderBy={orderBy}
          onSelectAllClick={onSelectAllClick}
          onRequestSort={onRequestSort}
          rowCount={rowCount}
          visibleColumns={visibleColumns}
        />
        <TableBody>
          {visibleRows.map((row, rowIndex) => {
            const isItemSelected = isSelected(row.id);
            const labelId = `enhanced-table-checkbox-${rowIndex}`;
            return (
              <TableRow
                key={row.id}
                hover
                onClick={(e) => handleClick(e, row.id, row)}
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                selected={isItemSelected}
                style={
                  isItemSelected
                    ? { background: "#d7e7fc" }
                    : row.status === "SI Closed"
                    ? {
                        background: "#898989",
                        textDecoration: "line-through",
                      }
                    : row.status === "SI Created"
                    ? { background: "#bdb9b9" }
                    : row.approvalStatus === "Approved"
                    ? { background: "#C8E6C9" }
                    : row.approvalStatus === "Not Approved"
                    ? { background: "#FFCDD2" }
                    : row.approvalStatus === "Waiting"
                    ? { background: "#FFF9C4" }
                    : { background: "#FFF9C4" }
                }
                sx={{
                  cursor: "pointer",
                }}
              >
                <TableCell padding="checkbox" id="checkbox-cell">
                  <Checkbox color="primary" checked={isItemSelected} inputProps={{ "aria-labelledby": labelId }} />
                </TableCell>
                {activeHeadCells.map((cell) => (
                  <TableCell
                   key={cell.id}
                   align="center" 
                   sx={cell.sx || {}}
                   id={`tableCell_${cell.id}`}>
                    {typeof cell.render === "function"
                      ? cell.render(row, rowIndex, {
                          setEditShipmentRequest,
                          retrieveUsers,
                          openAssignUserDialog,
                          closeAssignUserDialog, 
                          isAssignUserDialogOpen, 
                          selectedUser, 
                          setSelectedUser, 
                          users, 
                          handleAssignAndApprove,
                          handleDuplicate,
                          setShowSIPopup,
                          retrieveShipmentRequestByIdApi,
                          retrieveFilteredShipmentRequestsApi,
                          setEditItem,
                          setEditVendorOrder,
                          setEditCustomerOrder,
                          loadingRecord,
                        })
                      : row[cell.id] || ""}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
          {emptyRows > 0 && (
            <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
              <TableCell colSpan={activeHeadCells.length + 1} />
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

ShipmentRequestTable.propTypes = {
  visibleRows: PropTypes.array.isRequired,
  dense: PropTypes.bool.isRequired,
  isSelected: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  emptyRows: PropTypes.number.isRequired,
  visibleColumns: PropTypes.array.isRequired,
  setEditShipmentRequest: PropTypes.func.isRequired,
  retrieveUsers: PropTypes.func.isRequired,
  openAssignUserDialog: PropTypes.func.isRequired,
  closeAssignUserDialog: PropTypes.func.isRequired,
  isAssignUserDialogOpen: PropTypes.func.isRequired,
  selectedUser: PropTypes.func.isRequired,
  setSelectedUser: PropTypes.func.isRequired,
  users: PropTypes.func.isRequired,
  handleAssignAndApprove: PropTypes.func.isRequired,
  handleDuplicate: PropTypes.func.isRequired,
  setShowSIPopup: PropTypes.func.isRequired, 
  retrieveShipmentRequestByIdApi: PropTypes.func.isRequired,
  retrieveFilteredShipmentRequestsApi: PropTypes.func.isRequired,
  setEditItem: PropTypes.func.isRequired,
  setEditVendorOrder: PropTypes.func.isRequired,
  setEditCustomerOrder: PropTypes.func.isRequired,
  loadingRecord: PropTypes.any,
};

function EnhancedTableToolbar(props) {
  const {
    numSelected,
    showFilters,
    setShowFilters,
    rows,
    setAddView,
    selected,
    selectedData,
    visibleColumns,
    setVisibleColumns,
    selectedColumns,
    setSelectedColumns,
    selectColumnsDialogOpen,
    setSelectColumnsDialogOpen,
    columnsOrder, 
    setColumnsOrder,
    filterShipmentRequest,
    setRows,
  } = props;

  const headerMapping = {
    "Databox ID": "id",
    "Assigned To": "assignedUserName",
    "Type": "shipmentRequestType",
    "Shipment Quantity": (row) =>
      row?.shipmentQuantity
        ? { 
            v: Number(row.shipmentQuantity), 
            t: 'n',
            z: '#,##0.00'
          }
        : "",
    "SR To": "shipmentRequestTo",
    "PO ID": "purchaseOrderId",
    "PO Company": "purchaseOrderCompany",
    "SAP PO Number": "purchaseOrderNumber", 
    "PO Quantity": (row) =>
      row?.purchaseOrderVolume
        ? { 
            v: Number(row.purchaseOrderVolume), 
            t: 'n',
            z: '#,##0.00'
          }
        : "",
    "Supplier": "purchaseOrderStakeholderName",
    "Item ID": (row) => row?.salesOrderItemId || row?.purchaseOrderItemId || "",
    "Origin": (row) => row?.salesOrderItemOrigin || row?.purchaseOrderItemOrigin || "",
    "Item Type": (row) => row?.salesOrderItemType || row?.purchaseOrderItemType || "",
    "Buying Grade": (row) => row?.salesOrderItemBuyingGrade || row?.purchaseOrderItemBuyingGrade || "",
    "Sales Grade": "salesOrderSalesGrade",
    "Crop Year": (row) => row?.salesOrderItemCrop || row?.purchaseOrderItemCrop || "",
    "Storage": (row) => row?.salesOrderItemStorage || row?.purchaseOrderItemStorage || "",
    "SO ID": "salesOrderId",
    "SAP SO Number": "salesOrderNumber",
    "SO Company": "salesOrderCompany",
    "Customer": "salesOrderStakeholderName",
    "Customer Grade Mark": "customerGradeMark",
    "Warehouse": "warehouse",
    "Destination": "destination",
    "Port Of Loading": "portOfLoading",
    "Port Of Discharge": "portOfDischarge",
    "Number Of Cartons": "numberOfCases",
    "Net Weight Per Carton": "netWeightPerCase",
    "Cartons Per Container": "cartonsPerContainer",
    "Shipment ETD": (row) => 
      row?.shipmentEstimatedTimeOfDeparture
        ? format(new Date(row?.shipmentEstimatedTimeOfDeparture), "dd/MMM/yyyy")
        : "",
    "Approval Status": "approvalStatus",
    "Approval Date": (row) =>
      row?.approvalDate
        ? format(new Date(row?.approvalDate), "dd/MMM/yyyy")
        : "",
    "Status": "status",
    "Loading Remark": "loadingRemark",
    "Remark": "remark",
    "Reference SI": (row) => 
      `${row?.referenceShippingInstructionId || ""}-${row?.referenceShippingInstructionNumber || ""}`,
    "Creation Time": (row) =>
      row?.timestamp
        ? format(new Date(row.timestamp), "dd/MMM/yyyy HH:mm")
        : "",
    "Created By": "creator",
    "Record Status": "recordStatus"
  };
  

  const [manageExportOpen, setManageExportOpen] = useState(false);
  const [exportColumns, setExportColumns] = useState(Object.keys(headerMapping));
  const [exportColumnsOrder, setExportColumnsOrder] = useState(Object.keys(headerMapping));
const [showAddColumnInput, setShowAddColumnInput] = useState(false);
const [newColumnName, setNewColumnName] = useState('');
const [customColumns, setCustomColumns] = useState([]);

const [showMyShipmentRequests, setShowMyShipmentRequests] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState('');
  const [showNewReportInput, setShowNewReportInput] = useState(false);
  const [newReportName, setNewReportName] = useState('');
  const open = Boolean(anchorEl);
  const { user, loading } = useAuth();

    if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <div>Not authorized</div>;
  }

    const handleDragEnd = (event) => {
      const { active, over } = event;
      if (active.id !== over.id) {
        setColumnsOrder((items) => {
          const oldIndex = items.indexOf(active.id);
          const newIndex = items.indexOf(over.id);
          return arrayMove(items, oldIndex, newIndex);
        });
      }
    };
  
    const handleExportDragEnd = (event) => {
      const { active, over } = event;
      if (active.id !== over.id) {
        setExportColumnsOrder((items) => {
          const oldIndex = items.indexOf(active.id);
          const newIndex = items.indexOf(over.id);
          const newOrder = [...items];
          newOrder.splice(oldIndex, 1);
          newOrder.splice(newIndex, 0, active.id);
          return newOrder;
        });
      }
    };

    const handleToggle = (id) => {
      setSelectedColumns((prev) => {
        if (prev.includes(id)) {
          // Uncheck the item.
          return prev.filter(item => item !== id);
        } else {
          // Check the item.
          return [...prev, id];
        }
      });
    };

    const handleManageExportClick = async () => {
      try {
        const listResp = await retrieveUserReportsApi('ShipmentRequestExport');
              setReports(listResp?.data);            
              setSelectedReport(listResp?.data[0]?.reportName || 'default');
              const settings = await retrieveUserComponentSettingsApi('ShipmentRequestExport', listResp?.data[0]?.reportName || 'default');
        const allColumns = Object.keys(headerMapping);
        setExportColumnsOrder(allColumns);
        
        if (settings?.data?.visibleColumns) {
          try {
            // Try to parse the settings data
            let parsedSettings;
            
            if (typeof settings?.data?.visibleColumns === 'string') {
              parsedSettings = JSON.parse(settings?.data?.visibleColumns);
            } else {
              // If it's already an object, use it directly
              parsedSettings = settings?.data?.visibleColumns;
            }
    
            if (Array.isArray(parsedSettings)) {
              // Set the visible columns from saved settings
              setExportColumns(parsedSettings);
              
              // Create ordered array with visible columns first, then invisible ones
              const invisibleColumns = Object.keys(headerMapping).filter(
                col => !parsedSettings.includes(col)
              );
              
              setExportColumnsOrder([...parsedSettings, ...invisibleColumns]);
            } else {
              console.warn('Saved settings are not in array format:', parsedSettings);
              setExportColumns([]);
            }
          } catch (e) {
            console.warn('Failed to parse saved settings:', e);
            setExportColumns([]);
          }
        }
        setManageExportOpen(true);
      } catch (error) {
        console.error('Error loading export settings:', error);
        toast.error('Failed to load export settings');
      }
    };

    function createNewExportObject(rows) {
      const newObjects = [];
      rows.forEach((row) => {
        const newObject = {};
        exportColumnsOrder
          .filter(header => exportColumns.includes(header))
          .forEach((header) => {
            const pathOrFunction = headerMapping[header];
            let value;
            
            if (typeof pathOrFunction === "function") {
              value = pathOrFunction(row);
            } else if (pathOrFunction) { 
              const keys = pathOrFunction.split("?.");
              value = row;
              for (const key of keys) {
                if (value == null) break; 
                value = value[key];
              }
            }
            newObject[header] = value ?? ""; 
          });
        newObjects.push(newObject);
      });
      return newObjects;
    }

     async function loadSettings(reportName) {
      try {
        const resp = await retrieveUserComponentSettingsApi(
          'ShipmentRequestExport',
          reportName
        );
        let parsed = [];
        const raw = resp?.data?.visibleColumns;
        if (typeof raw === 'string') {
          parsed = JSON.parse(raw);
        } else if (Array.isArray(raw)) {
          parsed = raw;
        }
        setExportColumns(parsed);
        const allCols = Object.keys(headerMapping);
        const invisible = allCols.filter(c => !parsed.includes(c));
        setExportColumnsOrder([...parsed, ...invisible]);
      } catch (_) {
        const allCols = Object.keys(headerMapping);
        setExportColumns(allCols);
        setExportColumnsOrder(allCols);
      }
    }
    
    const handleDeleteReport = async () => {
      if (!selectedReport) return;
    
      if (selectedReport==="default") {
        toast.error('Default report cannot be deleted.');
        return;
      }
    
      if (!window.confirm(`Are you sure you want to delete "${selectedReport}"?`)) {
        return;
      }
    
      // find its DB id
      const report = reports.find(r => r.reportName === selectedReport);
      if (!report) return;
    
      try {
        // 1) mark it PASSIVE
        await deleteUserComponentSettingsApi('ShipmentRequestExport', selectedReport);
    
        toast.success(`Report "${selectedReport}" deleted`);
    
        // 2) remove it from local list
        const updated = reports.filter(r => r.id !== report.id);
        setReports(updated);
    
        // 3) pick a new selectedReport (or reset)
        const next = updated.length ? updated[0].reportName : '';
        setSelectedReport(next);
    
        if (next) {
          // load its saved columns
          await loadSettings(next);
        } else {
          // no reports left → reset to defaults
          const all = Object.keys(headerMapping);
          setExportColumns(all);
          setExportColumnsOrder(all);
        }
      } catch (err) {
        console.error(err);
        toast.error('Failed to delete report');
      }
    };

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity,
            ),
        }),
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Stack direction="row" spacing={1} alignItems={"center"}>
        <Typography
          sx={{ fontWeight: 600, fontSize: "20px" }}
          variant="h6"
          id="tableTitle"
          component="div"
          color="#1E2685"
        >
          Shipment Requests
        </Typography>

        <Typography></Typography>
        {numSelected > 0 ? (
          <Typography
            sx={{ fontWeight: 200, fontSize: "16px" }}
            color="#1E2685"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography></Typography>
        )}

         <FormControlLabel
          control={
            <Switch
              checked={showMyShipmentRequests}
              onChange={(e) => {
                setShowMyShipmentRequests(e.target.checked);
                if (e.target.checked) {
                  retrieveFastFilteredShipmentRequestsApi({
                    ...filterShipmentRequest,
                    currentUser: user?.email,
                  })
                    .then((response) => {
                      setRows(response?.data);
                    })
                    .catch((error) => {
                      console.log(error?.response?.data);
                      toast.error('Failed to filter shipping instructions');
                    });
                } else {
                  retrieveFastFilteredShipmentRequestsApi({
                    ...filterShipmentRequest,
                    currentUser: null,
                  })
                    .then((response) => {
                      setRows(response?.data);
                    })
                    .catch((error) => {
                      console.log(error?.response?.data);
                      toast.error('Failed to load shipping instructions');
                    });
                }
              }}
            />
          }
          label="Show Shipment Requests Assigned To Me"
          sx={{ ml: 2 }}
        />
      </Stack>
      <Stack spacing={1} direction="row" sx={{ mr: 2 }}>
          <Button
          disableElevation
          variant="outlined"
          size="small"
          onClick={() => setSelectColumnsDialogOpen(true)}
        >
          Select Columns
        </Button>
        
        <Dialog open={selectColumnsDialogOpen} onClose={() => setSelectColumnsDialogOpen(false)}>
          <DialogTitle>Select Columns</DialogTitle>
          <DialogContent>
            {/* Buttons to select/deselect all */}
            <Stack direction="row" spacing={2} mb={2}>
              <Button variant="outlined" onClick={() => setSelectedColumns([...columnsOrder])}>
                Select All
              </Button>
              <Button variant="outlined" onClick={() => setSelectedColumns([])}>
                Select None
              </Button>
              <Button
            variant="outlined"
            onClick={() => {
              const defaultOrder = headCells.map((cell) => cell.id);
              setColumnsOrder(defaultOrder);
              setSelectedColumns(defaultOrder);
            }}
          >
            Reset
          </Button>
            </Stack>
            {/* Use the DndContext and SortableContext for reordering */}
            <DndContext
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext items={columnsOrder} strategy={verticalListSortingStrategy}>
                {columnsOrder.map((columnId) => {
                  // Find the headCell data (label etc.) for this column id.
                  const column = headCells.find(cell => cell.id === columnId);
                  return (
                    <SortableItem
                      key={columnId}
                      id={columnId}
                      label={column.label || column.id}
                      checked={selectedColumns.includes(columnId)}
                      onToggle={() => handleToggle(columnId)}
                    />
                  );
                })}
              </SortableContext>
            </DndContext>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSelectColumnsDialogOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                // Get the ordered list of selected columns according to the current columnsOrder:
                const orderedSelectedColumns = columnsOrder.filter(id => selectedColumns.includes(id));
                const visibleColumnsJson = JSON.stringify(orderedSelectedColumns);
                saveUserComponentSettingsApi("ShipmentRequestView", "default", visibleColumnsJson)
                  .then((response) => {
                    toast.success("Column settings saved successfully!");
                    // Update the state that controls which columns are rendered in the table.
                    setVisibleColumns(orderedSelectedColumns);
                    setSelectColumnsDialogOpen(false);
                  })
                  .catch((error) => {
                    toast.error("Failed to save column settings.");
                    console.error("Save settings error:", error);
                  });
              }}
            >
              Save Column Settings
            </Button>
          </DialogActions>
        </Dialog>

        <Button
        disableElevation
        variant="outlined"
        size="small"
        onClick={handleManageExportClick}
      >
        Manage Export
      </Button>

      <Dialog 
        open={manageExportOpen} 
        onClose={() => setManageExportOpen(false)}
       maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            width: '600px'  // Set a fixed width
          }
        }}
      >
        <DialogTitle>Manage Export Settings</DialogTitle>
        <DialogContent>
                <FormControl fullWidth size="small" sx={{ mb: 2, display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
            <Select
              value={selectedReport}
              onChange={async (e) => {
                const name = e.target.value;
                setSelectedReport(name);
                await loadSettings(name);
              }}
              sx={{ flexGrow: 1 }}
            >
              {reports?.map(r => (
               <MenuItem key={r.id} value={r.reportName}>
                  {r.reportName}
                </MenuItem>
              ))}
            </Select>
          
            <IconButton
              size="small"
              onClick={() => setShowNewReportInput(true)}
              title="New report"
            >
              <AddIcon />
            </IconButton>
            <IconButton
              size="small"
              onClick={handleDeleteReport}
              disabled={!selectedReport}
              title="Delete report"
            >
              <DeleteIcon />
            </IconButton>
          </FormControl>
          {showNewReportInput && (
            <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
              <TextField
                size="small"
                value={newReportName}
                onChange={e => setNewReportName(e.target.value)}
                placeholder="New report name"
                fullWidth
              />
              <Button
                variant="contained"
                onClick={async () => {
                  const name = newReportName.trim();
                  if (!name) return;
                  const defaultCols = Object.keys(headerMapping);
                  await saveUserComponentSettingsApi('ShipmentRequestExport', name, JSON.stringify(defaultCols));
                  const updated = await retrieveUserReportsApi('ShipmentRequestExport');
                  setReports(updated?.data);
                  setSelectedReport(name);
                  await loadSettings(name);
                  setNewReportName('');
                  setShowNewReportInput(false);
                }}
              >
                Create
              </Button>
              <IconButton onClick={() => setShowNewReportInput(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
          )}
    <Stack direction="row" spacing={2} mb={2}>
      <Button 
        variant="outlined" 
        onClick={() => setExportColumns(Object.keys(headerMapping))}
      >
        Select All
      </Button>
      <Button 
        variant="outlined" 
        onClick={() => setExportColumns([])}
      >
        Select None
      </Button>
      <Button
        variant="outlined"
        onClick={() => {
          setExportColumns(Object.keys(headerMapping));
          setExportColumnsOrder(Object.keys(headerMapping));
        }}
      >
        Reset
      </Button>
      <Button 
        variant="outlined" 
        onClick={() => setShowAddColumnInput(true)}
      >
        Add Column
      </Button>
    </Stack>
     {showAddColumnInput && (
      <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
        <TextField
          size="small"
          value={newColumnName}
          onChange={(e) => setNewColumnName(e.target.value)}
          placeholder="Enter column name"
          fullWidth
        />
<Button
  variant="contained"
  onClick={() => {
    if (newColumnName.trim()) {
      const newColumn = newColumnName.trim().replace(/\s+/g, ' ');
      setCustomColumns([...customColumns, { id: newColumn, label: newColumnName }]);
      setExportColumns([...exportColumns, newColumn]);
      setExportColumnsOrder([...exportColumnsOrder, newColumn]);
      setNewColumnName('');
      setShowAddColumnInput(false);
    }
  }}
>
  Add
</Button>
        <IconButton onClick={() => setShowAddColumnInput(false)}>
          <CloseIcon />
        </IconButton>
      </Box>
    )}
    <DndContext
      collisionDetection={closestCenter}
      onDragEnd={handleExportDragEnd}
    >
     <SortableContext 
  items={exportColumnsOrder} 
  strategy={verticalListSortingStrategy}
>
  {exportColumnsOrder.map((columnId) => (
     <Box 
     key={columnId} 
     sx={{ 
       display: 'flex', 
       alignItems: 'center',
       gap: 1,
       width: '100%',
       // Minimal styling just for layout
       '& > div:first-of-type': {
         flex: 1
       }
     }}
   >
    <SortableItem
      key={columnId}
      id={columnId}
      label={columnId}
      checked={exportColumns.includes(columnId)}
      onToggle={() => {
        if (exportColumns.includes(columnId)) {
          setExportColumns(exportColumns.filter(col => col !== columnId));
        } else {
          setExportColumns([...exportColumns, columnId]);
        }
      }}
    />
    {customColumns.find(c => c.id === columnId) && (
      <IconButton
        size="small"
        onClick={() => {
          setCustomColumns(customColumns.filter(c => c.id !== columnId));
          setExportColumns(exportColumns.filter(col => col !== columnId));
          setExportColumnsOrder(exportColumnsOrder.filter(col => col !== columnId));
        }}
        sx={{ ml: 1 }}
      >
        <DeleteIcon />
      </IconButton>
    )}
  </Box>
))}
</SortableContext>
    </DndContext>
  </DialogContent>
        <DialogActions>
          <Button onClick={() => setManageExportOpen(false)}>Cancel</Button>
          <Button 
             onClick={() => {
              // Get visible columns in their current order
              const orderedVisibleColumns = exportColumnsOrder.filter(id => exportColumns.includes(id));
              
              // Stringify the array before saving
              const settingsString = JSON.stringify(orderedVisibleColumns);
              
              saveUserComponentSettingsApi('ShipmentRequestExport', selectedReport, settingsString)
                .then(() => {
                  toast.success('Export settings saved successfully');
                  setManageExportOpen(false);
                })
                .catch(error => {
                  console.error('Error saving export settings:', error);
                  toast.error('Failed to save export settings');
                });
            }}
            variant="contained"
          >
            Save Export Settings
          </Button>
           <ExportExcel
          excelData={createNewExportObject(selectedData)}
          fileName={"ShipmentRequest-"+selectedReport}
          buttonLabel="Export Table"
          buttonProps={{
           variant:"contained",
           color: "success",
           size: "medium",
         }}
        />
        </DialogActions>
      </Dialog>

        <Button
          disableElevation
          variant="outlined"
          size="small"
          onClick={() => setAddView(true)}
        >
          Add
        </Button>
        <Button
          variant="outlined"
          onClick={() => setShowFilters(!showFilters)}
          sx={{ minWidth: "130px", mr: 2 }}
          size="small"
        >
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
      </Stack>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function ShipmentRequestView() {
  const [rows, setRows] = useState([]);
  const componentName = "ShipmentRequestView";
  useEffect(() => {
    retrieveShipmentRequests();
  }, []);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [addView, setAddView] = useState(false);
  const [addViewStates, setAddViewStates] = useState(null);
  const [addViewStatesArray, setAddViewStatesArray] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [users, setUsers] = useState([]);
  const [isAssignUserDialogOpen, setIsAssignUserDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const totalShipmentQuantity = rows.reduce((sum, row) => sum + (row.shipmentQuantity || 0), 0);
  const [visibleColumns, setVisibleColumns] = useState(headCells.map(cell => cell.id));
  const [selectColumnsDialogOpen, setSelectColumnsDialogOpen] = useState(false);
  const [columnsOrder, setColumnsOrder] = useState(headCells.map(cell => cell.id));
  const [selectedColumns, setSelectedColumns] = useState(headCells.map(cell => cell.id));
  const [loadingRecord, setLoadingRecord] = useState(null);

  useEffect(() => {
      retrieveUserComponentSettingsApi(componentName, 'default')
        .then((response) => {
          const allColumnIds = headCells.map(cell => cell.id);
          if (response.data && response.data.visibleColumns) {
            const savedColumns = JSON.parse(response.data.visibleColumns); 
            const combinedOrder = [
              ...savedColumns,
              ...allColumnIds.filter(id => !savedColumns.includes(id))
            ];
            setVisibleColumns(savedColumns);      
            setColumnsOrder(combinedOrder);             
            setSelectedColumns(savedColumns);           
          } else {
            setVisibleColumns(allColumnIds);
            setColumnsOrder(allColumnIds);
            setSelectedColumns(allColumnIds);
          }
        })
        .catch((error) => {
          console.error("Error loading column settings:", error);
        });
    }, [componentName]);

    const handleColumnToggle = (columnId) => {
      setVisibleColumns(prev =>
        prev.includes(columnId)
          ? prev.filter(id => id !== columnId)
          : [...prev, columnId]
      );
    };
  function retrieveWarehouse() {
    retrieveAllWarehouseApi()
      .then((response) => {
        setWarehouses(response?.data);
        setDestinations(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const openAssignUserDialog = (row) => {
    setSelectedRow(row);
    setIsAssignUserDialogOpen(true);
  };

  const closeAssignUserDialog = () => {
    setIsAssignUserDialogOpen(false);
    setSelectedRow(null);
    setSelectedUser("");
  };

  const handleAssignAndApprove = () => {
    if (selectedRow && selectedUser) {
      retrieveShipmentRequestByIdApi(selectedRow.id)
        .then((response) => {
          const updatedRow = { 
            ...response.data, 
            assignedUser: selectedUser, 
            operationType: "ASSIGNMENT" 
          };
          return approveShipmentRequest(selectedRow.id, updatedRow);
        })
        .then(() => {
          closeAssignUserDialog();
        })
        .catch((error) => {
          console.log(error.response?.data);
        });
    }
  };

    const [quantity, setQuantity] = useState([]);

    // BURAYA BAK QUANTITYI SET ETMIYO ONDAN UYARI VERMİYO
    function retrieveQuantity(itemId) {
      retrieveQuantityByItemIdApi(itemId)
        .then((response) => {
          setQuantity(response?.data);
        })
        .catch((error) => console.log(error.response?.data));
    }

    const handleDuplicate = async (row) => {
      setLoadingRecord(row?.id);
      retrieveQuantity(row?.purchaseOrder ? row?.purchaseOrder?.offer?.item?.id : row?.salesOrder ? row?.salesOrder?.offer?.item?.id : "");
                   if (
                /^FW.*/.test(row?.shipmentRequestType) &&
                quantity?.quantityRemainingInWarehouseInNetKg -
                  row?.shipmentQuantity <
                  0
              ) {
                alert(`
        Selected item's:

        Remaining quantity in vendor: ${
          quantity?.quantityRemainingInVendorInNetKg || "N/A"
        } KG
        Remaining quantity in warehouse: ${
          quantity?.quantityRemainingInWarehouseInNetKg || "N/A"
        } KG
        Remaining quantity in production: ${
          quantity?.quantityRemainingInProductionInNetKg || "N/A"
        } KG
      `);
              } else if (
                /^FV.*/.test(row?.shipmentRequestType) &&
                quantity?.quantityRemainingInVendorInNetKg -
                  row?.shipmentQuantity <
                  0
              ) {
                alert(`
        Selected item's:

        Remaining quantity in vendor: ${
          quantity?.quantityRemainingInVendorInNetKg || "N/A"
        } KG
        Remaining quantity in warehouse: ${
          quantity?.quantityRemainingInWarehouseInNetKg || "N/A"
        } KG
        Remaining quantity in production: ${
          quantity?.quantityRemainingInProductionInNetKg || "N/A"
        } KG
      `);
              }
      const newRow = {
        ...row,
        purchaseOrderId: row?.purchaseOrder?.id,
        salesOrderId: row?.salesOrder?.id,
        status: "Open",
        approvalStatus: "Not Approved",
        approvalDate: "",
      };
       try {
      const response = await createShipmentRequestApi(newRow)
          toast.success("Shipment request duplicated successfully.");
          window.location.reload();
       }catch(error) {
          toast.error(error.response.data.message);
      }finally {
      setLoadingRecord(null);
    }
    };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const [componentsState, setComponentsState] = useState({
    item: {
      dropdownOpen: false,
      inputValue: "",
    },
        origin: {
      dropdownOpen: false,
      inputValue: "",
    },
    purchaseOrder: {
      dropdownOpen: false,
      inputValue: "",
    },
    salesOrder: {
      dropdownOpen: false,
      inputValue: "",
    },
    supplier: {
      dropdownOpen: false,
      inputValue: "",
    },
    customer: {
      dropdownOpen: false,
      inputValue: "",
    },
    destination: {
      dropdownOpen: false,
      inputValue: "",
    },
    warehouse: {
      dropdownOpen: false,
      inputValue: "",
    },
    portOfLoading: {
      dropdownOpen: false,
      inputValue: "",
    },
    portOfDischarge: {
      dropdownOpen: false,
      inputValue: "",
    },
    shipmentRequest: {
      dropdownOpen: false,
      inputValue: "",
    },
  });

  const updateComponentState = (componentKey, newState) => {
    setComponentsState((prevState) => ({
      ...prevState,
      [componentKey]: {
        ...prevState[componentKey],
        ...newState,
      },
    }));
  };

  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [salesOrders, setSalesOrders] = useState([]);
  const [items, setItems] = useState([]);

  const [filterShipmentRequest, setFilterShipmentRequest] = useState({
    id: 0,
    shipmentRequestTypeList: [],
    purchaseOrderIdList: [],
    salesOrderIdList: [],
    supplierIdList: [],
    itemIdList: [],
    idList: [],
    customerIdList: [],
    assignedUserIdList: [],
    destination: "",
    approvalStatusList: [],
    paymentStatusList: [],
    portOfLoadingList: [],
    portOfDischargeList: [],
    loadingRemark: "",
    remark: "",
    statusList: [],
    recordStatusList: ["ACTIVE"],
    originList: [],
    showEtdFields: false,
    estimatedTimeOfDepartureFrom: null,
    estimatedTimeOfDepartureTo: null,
  });

  const [editVendorOrder, setEditVendorOrder] = useState({
    visible: false,
    data: null,
    index: null,
  });

  const [editCustomerOrder, setEditCustomerOrder] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editItem, setEditItem] = useState({
    visible: false,
    data: null,
    index: null,
  });

  function mapShipmentRequest(shipmentRequest) {
    return {
      ...shipmentRequest, 
          assignedUserName: shipmentRequest?.assignedUser?.name,
          assignedUserEmail: shipmentRequest?.assignedUser?.email,
          purchaseOrderId: shipmentRequest?.purchaseOrder?.id,
          purchaseOrderCompany: shipmentRequest?.purchaseOrder?.company,
          purchaseOrderNumber: shipmentRequest?.purchaseOrder?.purchaseOrderNumber,
          purchaseOrderVolume: shipmentRequest?.purchaseOrder?.volume,
          purchaseOrderVolumeUnit: shipmentRequest?.purchaseOrder?.volumeUnit,
          purchaseOrderStakeholderName: shipmentRequest?.purchaseOrder?.offer?.stakeholder?.name,
          salesOrderItemId: shipmentRequest?.salesOrder?.offer?.item?.id,
          purchaseOrderItemId: shipmentRequest?.purchaseOrder?.offer?.item?.id,
          salesOrderItemOrigin: shipmentRequest?.salesOrder?.offer?.item?.origin,
          purchaseOrderItemOrigin: shipmentRequest?.purchaseOrder?.offer?.item?.origin,
          salesOrderItemType: shipmentRequest?.salesOrder?.offer?.item?.type,
          purchaseOrderItemType: shipmentRequest?.purchaseOrder?.offer?.item?.type,
          salesOrderItemBuyingGrade: shipmentRequest?.salesOrder?.offer?.item?.buyingGrade,
          purchaseOrderItemBuyingGrade: shipmentRequest?.purchaseOrder?.offer?.item?.buyingGrade,
          salesOrderSalesGrade: shipmentRequest?.salesOrder?.offer?.salesGrade,
          salesOrderItemCrop: shipmentRequest?.salesOrder?.offer?.item?.crop,
          purchaseOrderItemCrop: shipmentRequest?.purchaseOrder?.offer?.item?.crop,
          salesOrderDescriptionOfGoods: shipmentRequest?.salesOrder?.descriptionOfGoods,
          salesOrderItemStorage: shipmentRequest?.salesOrder?.offer?.item?.storage,
          purchaseOrderItemStorage: shipmentRequest?.purchaseOrder?.offer?.item?.storage,
          salesOrderSecondSampleStatus: shipmentRequest?.salesOrder?.secondSampleStatus,
          salesOrderId: shipmentRequest?.salesOrder?.id,
          salesOrderNumber: shipmentRequest?.salesOrder?.salesOrderNumber,
          salesOrderCompany: shipmentRequest?.salesOrder?.company,
          salesOrderStakeholderName: shipmentRequest?.salesOrder?.offer?.stakeholder?.name,
    };
  }

  function approveShipmentRequest(shipmentRequestId, shipmentRequest) {
    approveShipmentRequestApi(shipmentRequestId, shipmentRequest)
      .then((response) => { 
        toast.success("Shipment request approved successfully.");
        const row = mapShipmentRequest(shipmentRequest);
        const updatedRow = { ...row, 
          approvalStatus: "Approved"};
        if (rows && setRows) {
          const idx = rows.findIndex(row => row.id === updatedRow.id);
        
          if (idx !== -1) {
            const newRows = [...rows];
            newRows[idx] = updatedRow; 
            setRows(newRows); 
          }
        }
      })
      .catch((error) => {
        toast.error("No Authorization");
        console.log(error.response.data);
      });
  }

  function retrieveShipmentRequests() {
    retrieveFastShipmentRequestsApi()
      .then((response) => {
        setRows(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

    function retrieveItems() {
      retrieveAllItemsApi()
        .then((response) => {
          console.log("Items:", response?.data);
          setItems(response?.data);
        })
        .catch((error) => console.log(error.response?.data));
    }

  function retrieveOrderById(id) {
    retrieveOrderByIdApi(id)
      .then((response) => {
        setSelectedOrder(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveOrders(type) {
    retrieveFastOrdersApi(type)
      .then((response) => {
        if (type === "VENDOR") {
          setPurchaseOrders(response?.data);
        } else if (type === "CUSTOMER") {
          setSalesOrders(response?.data);
        }
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveStakeholders(type) {
    retrieveFastStakeholdersApi(type)
      .then((response) => {
        if (type === "VENDOR") {
          setVendors(response?.data);
        } else if (type === "CUSTOMER") {
          setCustomers(response?.data);
        }
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveUsers() {
    retrieveUsersApi()
      .then((response) => {
        setUsers(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const [editShipmentRequest, setEditShipmentRequest] = useState({
    visible: false,
    data: null,
    index: null,
  });

  const [showSIPopup, setShowSIPopup] = useState({
    visible: false,
    data: null,
  });

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      setSelectedData(rows);
      return;
    } else {
      setSelected([]);
      setSelectedData([]);
    }
  };

  const handleClick = (event, name, row) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    const selectedDataIndex = selectedData.indexOf(row);
    let newSelectedData = [];

    if (selectedDataIndex === -1) {
      newSelectedData = newSelectedData.concat(selectedData, row);
    } else if (selectedDataIndex === 0) {
      newSelectedData = newSelectedData.concat(selectedData.slice(1));
    } else if (selectedDataIndex === selectedData.length - 1) {
      newSelectedData = newSelectedData.concat(selectedData.slice(0, -1));
    } else if (selectedDataIndex > 0) {
      newSelectedData = newSelectedData.concat(
        selectedData.slice(0, selectedDataIndex),
        selectedData.slice(selectedDataIndex + 1),
      );
    }
    setSelectedData(newSelectedData);

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, rows, editShipmentRequest],
  );

  return (
    <div>
      {addView ? (
        <AddShipmentRequest
          setAddViewStates={setAddViewStates}
          addViewStates={addViewStates}
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          mapShipmentRequest = {mapShipmentRequest}
        />
      ) : showSIPopup.visible ? (
        <CreateSI
          setAddViewStatesArray={setAddViewStatesArray}
          addViewStatesArray={addViewStatesArray}
          setAddViewStates={setAddViewStates}
          addViewStates={addViewStates}
          rows={rows}
          setRows={setRows}
          showSIPopup={showSIPopup}
          setAddView={setShowSIPopup}
          type={"shipmentRequest"}
          mapFunction = {mapShipmentRequest}
        />
      ) : editVendorOrder.visible ? (
        <EditVendorOrder
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editVendorOrder={editVendorOrder}
          setEditVendorOrder={setEditVendorOrder}
        />
      ) : editCustomerOrder.visible ? (
        <EditCustomerOrder
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editCustomerOrder={editCustomerOrder}
          setEditCustomerOrder={setEditCustomerOrder}
        />
      ) : editItem.visible ? (
        <EditItem
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editItem={editItem}
          setEditItem={setEditItem}
        />
      ): editShipmentRequest.visible ? (
        <EditShipmentRequest
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          setAddViewStates={setAddViewStates}
          addViewStates={addViewStates}
          editShipmentRequest={editShipmentRequest}
          setEditShipmentRequest={setEditShipmentRequest}
          mapShipmentRequest = {mapShipmentRequest}
        />
      ) : (
        <>
          {showFilters && (
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-start"
                alignItems="center"
              >
                    <Autocomplete
        multiple
        id="outlined-select-shipment-request"
        disableClearable
        open={componentsState.shipmentRequest.dropdownOpen}
        onOpen={() => updateComponentState("shipmentRequest", { dropdownOpen: true })}
        inputValue={componentsState.shipmentRequest.inputValue}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === "input") {
            updateComponentState("shipmentRequest", { inputValue: newInputValue });
          }
        }}
        options={[
          ...rows.filter((shipmentRequest) =>
            filterShipmentRequest.idList.includes(shipmentRequest.id),
          ),
          ...rows.filter(
            (shipmentRequest) => !filterShipmentRequest.idList.includes(shipmentRequest.id),
          ),
        ]}
        getOptionLabel={(option) =>
          `${option?.id || ""} - ${option?.shipmentRequestType || ""} - Buying Grade: ${
            option?.purchaseOrderItemId || ""
          } - ${
            option?.purchaseOrderItemBuyingGrade || ""
          } - ${option?.purchaseOrderItemCrop || ""}`
        }
        value={rows.filter((shipmentRequest) =>
          filterShipmentRequest.idList.includes(shipmentRequest.id),
        )}
        onChange={(event, newValue) => {
          setFilterShipmentRequest({
            ...filterShipmentRequest,
            idList: newValue
            .map((shipmentRequest) => shipmentRequest.id)
            .filter((id) => id !== null),
          });
        }}
        renderOption={(props, option, { selected }) => (
          <li
            {...props}
            style={{
              ...props.style,
              backgroundColor: selected ? "lightblue" : undefined,
              fontWeight: selected ? 700 : 400,
            }}
          >
            {`${option?.id || ""} - ${option?.shipmentRequestType || ""} - Buying Grade: ${
              option?.purchaseOrderItemId || ""
            } - ${
              option?.purchaseOrderItemBuyingGrade || ""
            } - ${option?.purchaseOrderItemCrop || ""}`}
          </li>
        )}
        renderInput={(params) => {
          const label =
            filterShipmentRequest?.idList.length > 0
              ? `Shipment Requests Selected (${filterShipmentRequest?.idList.length})`
              : "Shipment Request";

          return (
            <TextField
              {...params}
              label={label}
              type="search"
              value={componentsState.shipmentRequest.inputValue}
              onChange={(e) =>
                updateComponentState("shipmentRequest", { inputValue: e.target.value })
              }
              InputProps={{
                ...params.InputProps,
                style: { height: 42 },
              }}
              onBlur={() =>
                updateComponentState("shipmentRequest", { dropdownOpen: false })
              }
            />
          );
        }}
        renderTags={() => null}
      />

      <FilterSelect
        label="Type"
        menuType="shipmentRequestTypes"
        value={filterShipmentRequest.shipmentRequestTypeList || []}
        onChange={(e) =>  setFilterShipmentRequest({
                        ...filterShipmentRequest,
                        shipmentRequestTypeList: e.target.value,
                      })}
        multiple
      />

      <Autocomplete
        multiple
        id="outlined-select-item"
        disableClearable
        open={componentsState.item.dropdownOpen}
        onOpen={() => updateComponentState("item", { dropdownOpen: true })}
        inputValue={componentsState.item.inputValue}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === "input") {
            updateComponentState("item", { inputValue: newInputValue });
          }
        }}
        options={[
          ...items.filter((item) =>
            filterShipmentRequest.itemIdList.includes(item.id),
          ),
          ...items.filter(
            (item) => !filterShipmentRequest.itemIdList.includes(item.id),
          ),
        ]}
        getOptionLabel={(option) =>
          `${option?.id || ""} - ${option?.buyingGrade || ""} - ${
            option?.crop || ""
          } - ${option?.origin || ""}`
        }
        value={items.filter((item) =>
          filterShipmentRequest.itemIdList.includes(item.id),
        )}
        onChange={(event, newValue) => {
          setFilterShipmentRequest({
            ...filterShipmentRequest,
            itemIdList: newValue
            .map((item) => item.id)
            .filter((id) => id !== null),
          });
        }}
        renderOption={(props, option, { selected }) => (
          <li
            {...props}
            style={{
              ...props.style,
              backgroundColor: selected ? "lightblue" : undefined,
              fontWeight: selected ? 700 : 400,
            }}
          >
            {`${option?.id || ""} - ${option?.buyingGrade || ""} - ${
              option?.crop || ""
            } - ${option?.origin || ""}`}
          </li>
        )}
        renderInput={(params) => {
          const label =
            filterShipmentRequest?.itemIdList.length > 0
              ? `Items Selected (${filterShipmentRequest?.itemIdList.length})`
              : "Item";

          return (
            <TextField
              {...params}
              label={label}
              type="search"
              value={componentsState.item.inputValue}
              onChange={(e) =>
                updateComponentState("item", { inputValue: e.target.value })
              }
              onMouseDown={() => retrieveItems()}
              InputProps={{
                ...params.InputProps,
                style: { height: 42 },
              }}
              onBlur={() =>
                updateComponentState("item", { dropdownOpen: false })
              }
            />
          );
        }}
        renderTags={() => null}
      />

   <FilterSelect
        label="Origin"
        menuType="origin"
        value={filterShipmentRequest?.originList || []}
        onChange={(e) => setFilterShipmentRequest({
            ...filterShipmentRequest,
            originList: e.target.value,
          })}
        multiple
      />

                <Autocomplete
                  multiple
                  id="outlined-select-po"
                  disableClearable
                  open={componentsState.purchaseOrder.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("purchaseOrder", {
                      dropdownOpen: true,
                    })
                  }
                  inputValue={componentsState.purchaseOrder.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("purchaseOrder", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...purchaseOrders.filter((purchaseOrder) =>
                      filterShipmentRequest.purchaseOrderIdList.includes(
                        purchaseOrder.id,
                      ),
                    ),
                    ...purchaseOrders.filter(
                      (purchaseOrder) =>
                        !filterShipmentRequest.purchaseOrderIdList.includes(
                          purchaseOrder.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `ID: ${option?.id || ""}, PO Number: ${option?.purchaseOrderNumber || ""}, Item Buying Grade: ${
                      option?.offerItemBuyingGrade || ""
                    }, 
                       Origin: ${option?.offerItemOrigin || ""}, Crop: ${
                      option?.offerItemCrop || ""
                    }`
                  }
                  value={purchaseOrders.filter((purchaseOrder) =>
                    filterShipmentRequest.purchaseOrderIdList.includes(
                      purchaseOrder.id,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShipmentRequest({
                      ...filterShipmentRequest,
                      purchaseOrderIdList: newValue
                        .map((purchaseOrder) => purchaseOrder.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`ID: ${option?.id || ""}, PO Number: ${option?.purchaseOrderNumber || ""}, Item Buying Grade: ${
                        option?.offerItemBuyingGrade || ""
                      }, 
                       Origin: ${option?.offerItemOrigin || ""}, Crop: ${
                        option?.offerItemCrop || ""
                      }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterShipmentRequest?.purchaseOrderIdList.length > 0
                        ? `POs Selected (${filterShipmentRequest?.purchaseOrderIdList.length})`
                        : "PO";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.purchaseOrder.inputValue}
                        onChange={(e) => {
                          updateComponentState("purchaseOrder", {
                            inputValue: e.target.value,
                          });
                        }}
                        onMouseDown={() => retrieveOrders("VENDOR")}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("purchaseOrder", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <Autocomplete
                  multiple
                  id="outlined-select-supplier"
                  disableClearable
                  open={componentsState.supplier.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("supplier", { dropdownOpen: true })
                  }
                  inputValue={componentsState.supplier.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("supplier", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...vendors.filter((option) =>
                      filterShipmentRequest.supplierIdList.includes(option.id),
                    ),
                    ...vendors.filter(
                      (option) =>
                        !filterShipmentRequest.supplierIdList.includes(
                          option.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.name || ""}`
                  }
                  value={vendors.filter((option) =>
                    filterShipmentRequest.supplierIdList.includes(option.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShipmentRequest({
                      ...filterShipmentRequest,
                      supplierIdList: newValue.map((option) => option.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.name || ""}`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterShipmentRequest?.supplierIdList.length > 0
                        ? `Vendors Selected (${filterShipmentRequest?.supplierIdList.length})`
                        : "Vendor";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.supplier.inputValue}
                        onChange={(e) =>
                          updateComponentState("supplier", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={() => retrieveStakeholders("VENDOR")}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("supplier", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <Autocomplete
                  multiple
                  id="outlined-select-so"
                  disableClearable
                  open={componentsState.salesOrder.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("salesOrder", { dropdownOpen: true })
                  }
                  inputValue={componentsState.salesOrder.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("salesOrder", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...salesOrders.filter((salesOrder) =>
                      filterShipmentRequest.salesOrderIdList.includes(
                        salesOrder.id,
                      ),
                    ),
                    ...salesOrders.filter(
                      (salesOrder) =>
                        !filterShipmentRequest.salesOrderIdList.includes(
                          salesOrder.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `ID: ${option?.id || ""}, SO Number: ${option?.salesOrderNumber || ""}, Item Buying Grade: ${
                      option?.offerItemBuyingGrade || ""
                    }, 
                       Origin: ${option?.offerItemOrigin || ""}, Crop: ${
                      option?.offerItemCrop || ""
                    }`
                  }
                  value={salesOrders.filter((salesOrder) =>
                    filterShipmentRequest.salesOrderIdList.includes(
                      salesOrder.id,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShipmentRequest({
                      ...filterShipmentRequest,
                      salesOrderIdList: newValue
                        .map((salesOrder) => salesOrder.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`ID: ${option?.id || ""}, SO Number: ${option?.salesOrderNumber || ""}, Item Buying Grade: ${
                        option?.offerItemBuyingGrade || ""
                      }, 
                       Origin: ${option?.offerItemOrigin || ""}, Crop: ${
                        option?.offerItemCrop || ""
                      }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterShipmentRequest?.salesOrderIdList.length > 0
                        ? `SOs Selected (${filterShipmentRequest?.salesOrderIdList.length})`
                        : "SO";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.salesOrder.inputValue}
                        onChange={(e) => {
                          updateComponentState("salesOrder", {
                            inputValue: e.target.value,
                          });
                        }}
                        onMouseDown={() => retrieveOrders("CUSTOMER")}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("salesOrder", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <Autocomplete
                  multiple
                  id="outlined-select-customer"
                  disableClearable
                  open={componentsState.customer.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("customer", { dropdownOpen: true })
                  }
                  inputValue={componentsState.customer.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("customer", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...customers.filter((option) =>
                      filterShipmentRequest.customerIdList.includes(option.id),
                    ),
                    ...customers.filter(
                      (option) =>
                        !filterShipmentRequest.customerIdList.includes(
                          option.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.name || ""}`
                  }
                  value={customers.filter((option) =>
                    filterShipmentRequest.customerIdList.includes(option.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShipmentRequest({
                      ...filterShipmentRequest,
                      customerIdList: newValue.map((option) => option.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.name || ""}`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterShipmentRequest?.customerIdList.length > 0
                        ? `Customers Selected (${filterShipmentRequest?.customerIdList.length})`
                        : "Customer";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.customer.inputValue}
                        onChange={(e) =>
                          updateComponentState("customer", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={() => retrieveStakeholders("CUSTOMER")}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("customer", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <TextField
                  label="Assigned User"
                  type="search"
                  id="outlined-select-assigned-user"
                  select
                  onMouseDown={retrieveUsers}
                  SelectProps={{
                    multiple: true,
                    value: filterShipmentRequest.assignedUserIdList || [],
                    onChange: (e) => {
                      setFilterShipmentRequest({
                        ...filterShipmentRequest,
                        assignedUserIdList: e.target.value,
                      });
                    },
                  }}
                >
                  {users.map((option) => (
                    <MenuItem key={option?.id} value={option?.id}>
                      {option?.name}
                    </MenuItem>
                  ))}
                </TextField>

                <Autocomplete
                  multiple
                  id="outlined-select-warehouse"
                  disableClearable
                  open={componentsState.warehouse.dropdownOpen}
                  onOpen={() => updateComponentState("warehouse", { dropdownOpen: true })}
                  inputValue={componentsState.warehouse.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("warehouse", { inputValue: newInputValue });
                    }
                  }}
                  options={warehouses}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.code || ""} - ${
                      option?.name || ""}`
                  }
                  value={warehouses.filter((warehouse) =>
                    filterShipmentRequest?.warehouseList?.includes(warehouse.name),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShipmentRequest({
                      ...filterShipmentRequest,
                      warehouseList: newValue.map((warehouse) => warehouse.name),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.code || ""} - ${
                      option?.name || ""}`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                    filterShipmentRequest?.warehouseList?.length > 0
                        ? `Warehouses Selected (${filterShipmentRequest?.warehouseList?.length})`
                        : "Warehouse";
          
                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.warehouse.inputValue}
                        onChange={(e) =>
                          updateComponentState("warehouse", { inputValue: e.target.value })
                        }
                        onMouseDown={retrieveWarehouse}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("warehouse", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />
                
                <Autocomplete
                  multiple
                  id="outlined-select-destination"
                  disableClearable
                  open={componentsState.destination.dropdownOpen}
                  onOpen={() => updateComponentState("destination", { dropdownOpen: true })}
                  inputValue={componentsState.destination.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("destination", { inputValue: newInputValue });
                    }
                  }}
                  options={destinations}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.code || ""} - ${
                      option?.name || ""}`
                  }
                  value={destinations.filter((destination) =>
                    filterShipmentRequest?.destinationList?.includes(destination.name),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShipmentRequest({
                      ...filterShipmentRequest,
                      destinationList: newValue.map((destination) => destination.name),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.code || ""} - ${
                      option?.name || ""}`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                    filterShipmentRequest?.destinationList?.length > 0
                        ? `Destinations Selected (${filterShipmentRequest?.destinationList?.length})`
                        : "Destination";
          
                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.destination.inputValue}
                        onChange={(e) =>
                          updateComponentState("destination", { inputValue: e.target.value })
                        }
                        onMouseDown={retrieveWarehouse}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("destination", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

   <FilterSelect
        label="Port Of Loading"
        menuType="portsOfLoading"
        value={filterShipmentRequest?.portOfLoadingList}
        onChange={(e) => setFilterShipmentRequest({
            ...filterShipmentRequest,
            portOfLoadingList: e.target.value,
          })}
        multiple
      />

      <FilterSelect
        label="Port Of Discharge"
        menuType="portsOfDischarge"
        value={filterShipmentRequest?.portOfDischargeList}
        onChange={(e) => setFilterShipmentRequest({
            ...filterShipmentRequest,
            portOfDischargeList: e.target.value,
          })}
        multiple
      />

                <TextField
                  id="outlined-number-of-cases"
                  label="Number Of Cartons"
                  value={filterShipmentRequest?.numberOfCases || ""}
                  type="number"
            onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterShipmentRequest({
                      ...filterShipmentRequest,
                      numberOfCases: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-net-weight-per-case"
                  label="Net Weight Per Carton"
                  value={filterShipmentRequest?.netWeightPerCase || ""}
                  type="number"
            onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterShipmentRequest({
                      ...filterShipmentRequest,
                      netWeightPerCase: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-shipment-quantity"
                  label="Shipment Quantity"
                  value={filterShipmentRequest?.shipmentQuantity || ""}
                  type="number"
            onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterShipmentRequest({
                      ...filterShipmentRequest,
                      shipmentQuantity: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-cartons-per-container"
                  label="Cartons Per Container"
                  value={filterShipmentRequest?.cartonsPerContainer || ""}
                  type="number"
            onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterShipmentRequest({
                      ...filterShipmentRequest,
                      cartonsPerContainer: e.target.value,
                    })
                  }
                />
             
                <TextField
                  id="date"
                  type="date"
                  label="Shipment ETD"
                  value={filterShipmentRequest?.shipmentEstimatedTimeOfDeparture || ""}
                  onKeyDown={(e) => e.preventDefault()}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) =>
                    setFilterShipmentRequest({
                      ...filterShipmentRequest,
                      shipmentEstimatedTimeOfDeparture: e.target.value,
                    })
                  }
                />
             
                <ClickAwayListener
                  onClickAway={() => {
                    if (filterShipmentRequest?.showEtdFields) {
                      setFilterShipmentRequest({
                        ...filterShipmentRequest,
                        showEtdFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="etd"
                      type="text"
                      label="ETD"
                      fullWidth
                      variant="outlined"
                      value={
                        filterShipmentRequest?.estimatedTimeOfDepartureFrom && filterShipmentRequest?.estimatedTimeOfDepartureTo
                          ? `${filterShipmentRequest.estimatedTimeOfDepartureFrom}, ${filterShipmentRequest.estimatedTimeOfDepartureTo}`
                          : filterShipmentRequest?.estimatedTimeOfDepartureFrom
                            ? `From ${filterShipmentRequest.estimatedTimeOfDepartureFrom}`
                            : filterShipmentRequest?.estimatedTimeOfDepartureTo
                              ? `To ${filterShipmentRequest.estimatedTimeOfDepartureTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterShipmentRequest({
                          ...filterShipmentRequest,
                          showEtdFields: true,
                        })
                      }
                    />
                    {filterShipmentRequest?.showEtdFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="etd-from"
                          type="date"
                          label="From"
                          value={filterShipmentRequest?.estimatedTimeOfDepartureFrom || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterShipmentRequest({
                              ...filterShipmentRequest,
                              estimatedTimeOfDepartureFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="etd-to"
                          type="date"
                          label="To"
                          value={filterShipmentRequest?.estimatedTimeOfDepartureTo || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterShipmentRequest({
                              ...filterShipmentRequest,
                              estimatedTimeOfDepartureTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterShipmentRequest({
                              ...filterShipmentRequest,
                              showEtdFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <TextField
                  id="outlined-search"
                  label="Remark"
                  value={filterShipmentRequest?.remark || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterShipmentRequest({
                      ...filterShipmentRequest,
                      remark: e.target.value,
                    })
                  }
                />
                      <FilterSelect
                        label="Approval Status"
                        menuType="status"
                        value={filterShipmentRequest.approvalStatusList || []}
                        onChange={(e) =>  setFilterShipmentRequest({
                        ...filterShipmentRequest,
                        approvalStatusList: e.target.value,
                      })}
                        multiple
                      />
                      <FilterSelect
                        label="Status"
                        menuType="shipmentRequestStatus"
                        value={filterShipmentRequest.statusList || []}
                        onChange={(e) =>  setFilterShipmentRequest({
                        ...filterShipmentRequest,
                        statusList: e.target.value,
                      })}
                        multiple
                      />
                      <FilterSelect
                        label="Record Status"
                        menuType="recordStatus"
                        value={filterShipmentRequest.recordStatusList || []}
                        onChange={(e) =>  setFilterShipmentRequest({
                        ...filterShipmentRequest,
                        recordStatusList: e.target.value,
                      })}
                        multiple
                      />
                           <MyFilters
                          componentName="ShipmentRequestView"
                          filterState={filterShipmentRequest}
                          onApply={(saved) => setFilterShipmentRequest(saved)}
                        />
              </Grid>
              <br></br>
              <Grid
                container
                spacing={2}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      retrieveFastFilteredShipmentRequestsApi(filterShipmentRequest)
                        .then((response) => {
                          setRows(response?.data);
                        })
                        .catch((error) => {
                          console.log(error?.response?.data);
                        });
                    }}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="outlined"
                    fullWidth
                    onClick={() => {
                      setFilterShipmentRequest({
                        id: 0,
                        shipmentRequestTypeList: [],
                        purchaseOrderIdList: [],
                        salesOrderIdList: [],
                        supplierIdList: [],
                        itemIdList: [],
                        idList: [],
                        customerIdList: [],
                        destination: "",
                        destinationList: [],
                        warehouseList: [],
                        approvalStatusList: [],
                        paymentStatusList: [],
                        portOfLoadingList: [],
                        portOfDischargeList: [],
                        loadingRemark: "",
                        remark: "",
                        netWeightPerCase: null,
                        numberOfCases: null,
                        shipmentQuantity: null,
                        cartonsPerContainer: null,
                        statusList: [],
                        recordStatusList: ["ACTIVE"],
                        shipmentEstimatedTimeOfDeparture: "",
                        approvalDate: "",
                        originList: [],
                      });
                    }}
                  >
                    Clear Filters
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}

          <Box sx={{ width: "100%", mt: 2 }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <EnhancedTableToolbar
                numSelected={selected.length}
                showFilters={showFilters}
                setShowFilters={setShowFilters}
                rows={rows}
                setAddView={setAddView}
                selected={selected}
                selectedData={selectedData}
                visibleColumns={visibleColumns}
                setVisibleColumns={setVisibleColumns}
                selectedColumns = {selectedColumns}
                setSelectedColumns = {setSelectedColumns}
                selectColumnsDialogOpen={selectColumnsDialogOpen}
                setSelectColumnsDialogOpen={setSelectColumnsDialogOpen}
                columnsOrder = {columnsOrder}
                setColumnsOrder = {setColumnsOrder}
                filterShipmentRequest={filterShipmentRequest}
                setRows={setRows}
              />
                        <ShipmentRequestTable
                          visibleRows={visibleRows}
                          dense={dense}
                          isSelected={isSelected}
                          handleClick={handleClick}
                          emptyRows={emptyRows}
                          visibleColumns={visibleColumns}
                          order={order}
                          orderBy={orderBy}
                          onRequestSort={handleRequestSort}
                          numSelected={selected.length}
                          rowCount={rows.length}
                          onSelectAllClick={handleSelectAllClick}
                          setEditShipmentRequest = {setEditShipmentRequest}
                          retrieveUsers = {retrieveUsers}
                          openAssignUserDialog = {openAssignUserDialog}
                          closeAssignUserDialog = {closeAssignUserDialog} 
                          isAssignUserDialogOpen = {isAssignUserDialogOpen}
                          selectedUser = {selectedUser}
                          setSelectedUser = {setSelectedUser}
                          users = {users}
                          handleAssignAndApprove = {handleAssignAndApprove}
                          handleDuplicate = {handleDuplicate}
                          setShowSIPopup = {setShowSIPopup}
                          retrieveShipmentRequestByIdApi={retrieveShipmentRequestByIdApi}
                          retrieveFilteredShipmentRequestsApi={retrieveFilteredShipmentRequestsApi}
                          setEditCustomerOrder={setEditCustomerOrder}
                          setEditItem={setEditItem}
                          setEditVendorOrder = {setEditVendorOrder}
                          loadingRecord={loadingRecord}
                        />
              {/*<TableContainer style={{ maxHeight: 700 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  sx={{
                    minWidth: 750,
                    "& .MuiTableCell-root": {
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                    },
                    "& .MuiTableCell-head": {
                      backgroundColor: "#20315d",
                      color: "white",
                      borderRight: "1px solid rgba(49, 64, 128, 1)",
                    },
                  }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  style={{ width: "max-content" }}
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                    visibleColumns={visibleColumns}
                  />
                  <TableBody>
                    {visibleRows.map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          style={
                            isSelected(row.id)
                              ? { background: "#d7e7fc" }
                              : row.status === "SI Closed"
                              ? {
                                  background: "#898989",
                                  textDecoration: "line-through",
                                }
                              : row.status === "SI Created"
                              ? { background: "#bdb9b9" }
                              : row.approvalStatus === "Approved"
                              ? { background: "#C8E6C9" }
                              : row.approvalStatus === "Not Approved"
                              ? { background: "#FFCDD2" }
                              : row.approvalStatus === "Waiting"
                              ? { background: "#FFF9C4" }
                              : //: index % 2
                                //? { background: '#f0f0f0' }
                                { background: "#FFF9C4" }
                          }
                          hover
                          onClick={(event) => handleClick(event, row.id, row)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          selected={isItemSelected}
                          sx={{ cursor: "pointer" }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                          </TableCell>
                          <TableCell padding="normal">
                            <Button
                              onClick={(e) => {
                                if (!row?.id) {
                                  alert("Please refresh the page.");
                                  return;
                                }
                                e.preventDefault();
                                if (row?.status === "SI Created") {
                                  alert("An SI is connected to this SR.");
                                } else if (row?.status === "SI Closed") {
                                  alert(
                                    "An SI connected to this SR is closed. Editing is not allowed.",
                                  );
                                  return;
                                }
                                setEditShipmentRequest({
                                  visible: true,
                                  data: row,
                                  index: index,
                                });
                              }}
                            >
                              Edit
                            </Button>
                          </TableCell>
                          <TableCell padding="normal">
                            <Button
                              variant="outlined"
                              disabled={row?.approvalStatus === "Approved"}
                              onMouseDown={retrieveUsers}
                              onClick={() => {
                                if (!row?.id) {
                                  alert("Please refresh the page.");
                                  return;
                                }
                                retrieveShipmentRequestByIdApi(row?.id)
                                .then((response) => {
                                  openAssignUserDialog(response?.data)
                                })
                                .catch((error) => {
                                  console.error("Error fetching shipment request data:", error);
                                  toast.error("Failed to retrieve shipment request details. Please try again later.");
                                });
                                }
                              }
                            >
                              Approve
                            </Button>
                          </TableCell>
                          <Dialog
                            open={isAssignUserDialogOpen}
                            onClose={closeAssignUserDialog}
                          >
                            <DialogTitle>
                              Assign Shipment Request to a User
                            </DialogTitle>
                            <DialogContent>
                              <Select
                                value={selectedUser}
                                onChange={(e) =>
                                  setSelectedUser(e.target.value)
                                }
                                displayEmpty
                                fullWidth
                              >
                                <MenuItem value="" disabled>
                                  Select a User
                                </MenuItem>
                                {users.map((user) => (
                                  <MenuItem key={user} value={user}>
                                    {user.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={closeAssignUserDialog}>
                                Cancel
                              </Button>
                              <Button
                                onClick={handleAssignAndApprove}
                                disabled={!selectedUser}
                              >
                                Approve
                              </Button>
                            </DialogActions>
                          </Dialog>
                          <TableCell padding="normal">
                            <Button
                              style={{ width: "max-content" }}
                              disabled={
                                row?.approvalStatus !== "Approved" ||
                                row?.status === "SI Created" ||
                                row?.status === "SI Closed"
                              }
                              onClick={() => {
                                if (
                                  localStorage.getItem("username") ===
                                  row?.assignedUserEmail
                                ) {
                                  retrieveShipmentRequestByIdApi(row?.id)
                                  .then((response) => {
                                    setShowSIPopup({ data: response?.data, visible: true });
                                  })
                                  .catch((error) => {
                                    console.error("Error fetching shipment request data:", error);
                                    toast.error("Failed to retrieve shipment request details. Please try again later.");
                                  });
                              }else {
                                  toast.error(
                                    "You are not the assigned user for this SI.",
                                  );
                                }
                              }}
                            >
                              Create SI
                            </Button>
                          </TableCell>
                          <TableCell align="center">{row?.id}</TableCell>
                          <TableCell align="center">
                            {row?.assignedUserName}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shipmentRequestType}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shipmentQuantity
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.shipmentQuantity)} ${
                                  row?.shipmentQuantityUnit
                                }`
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shipmentRequestTo}
                          </TableCell>
                          <TableCell align="center">
                          <OrderButton
                              row={row}
                              id={row?.purchaseOrderId}
                              setEditOrder={setEditVendorOrder}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {row?.purchaseOrderCompany}
                          </TableCell>
                          <TableCell align="center">
                            {row?.purchaseOrderNumber}
                          </TableCell>
                          <TableCell align="center">
                            {row?.purchaseOrderVolume
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row?.purchaseOrderVolume)} ${
                                  row?.purchaseOrderVolumeUnit
                                }`
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.purchaseOrderStakeholderName || ""}
                          </TableCell>
                          <TableCell align="center">
                          <ItemButton
                              row={row}
                              id={row?.salesOrderItemId ||
                                row?.purchaseOrderItemId ||
                                ""}
                              setEditItem={setEditItem}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderItemOrigin ||
                              row?.purchaseOrderItemOrigin ||
                              ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderItemType ||
                              row?.purchaseOrderItemType ||
                              ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderItemBuyingGrade ||
                              row?.purchaseOrderItemBuyingGrade ||
                              ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderSalesGrade ||
                              ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderItemCrop ||
                              row?.purchaseOrderItemCrop ||
                              ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderDescriptionOfGoods?.length >
                            50 ? (
                              <span
                                style={{
                                  display: "inline-block",
                                  maxWidth: "350px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  verticalAlign: "top",
                                }}
                                title={row?.salesOrderDescriptionOfGoods}
                              >
                                {row?.salesOrderDescriptionOfGoods}
                              </span>
                            ) : (
                              row?.salesOrderDescriptionOfGoods
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderItemStorage ||
                              row?.purchaseOrderItemStorage ||
                              ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderSecondSampleStatus || ""}
                          </TableCell>
                          <TableCell align="center">
                          <OrderButton
                              row={row}
                              id={row?.salesOrderId}
                              setEditOrder={setEditCustomerOrder}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderNumber || ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderCompany}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderStakeholderName || ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.customerGradeMark || ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.warehouse || ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.destination || ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.portOfLoading || ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.portOfDischarge || ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.numberOfCases || ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.netWeightPerCase || ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.cartonsPerContainer || ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shipmentEstimatedTimeOfDeparture
                              ? format(
                                  new Date(
                                    row?.shipmentEstimatedTimeOfDeparture,
                                  ),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.approvalStatus || ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.approvalDate
                              ? format(
                                  new Date(row?.approvalDate),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">{row?.status}</TableCell>
                          <TableCell align="center">
                            {row?.loadingRemark}
                          </TableCell>
                          <TableCell align="center">{row?.remark}</TableCell>

                          <TableCell align="center">
                          {row?.referenceShippingInstructionId}-{row?.referenceShippingInstructionNumber}
                          </TableCell>
                          <TableCell align="center">
                            {row?.timestamp
                              ? format(
                                  new Date(row.timestamp),
                                  "dd/MM/yyyy HH:mm",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">{row?.creator}</TableCell>
                          <TableCell align="center">
                            {row?.recordStatus}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: (dense ? 33 : 53) * emptyRows,
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>*/}
               <div style={{ 
                       position: "sticky", 
                       top: 0, 
                       background: "white", 
                       padding: "10px", 
                       fontWeight: "bold", 
                       borderBottom: "1px solid #ddd", 
                       zIndex: 10, 
                       display: "flex", 
                       gap: "20px"
                     }}>
                         <span>Total Shipment Quantity: {new Intl.NumberFormat("en-US", { 
                         style: "decimal", 
                         minimumFractionDigits: 2 
                       }).format(totalShipmentQuantity)} {rows.length > 0 ? "KG" : ""}</span>
              </div>
              <div style={{ marginTop: "20px", marginLeft: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        background: "#c8e6c9",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: "8px",
                        display: "inline-block",
                      }}
                    >
                      Approved
                    </span>
                    <span>- Shipment request approved</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        background: "#FFCDD2",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: "8px",
                        display: "inline-block",
                      }}
                    >
                      Not Approved
                    </span>
                    <span>- Shipment request not approved</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        background: "#bdb9b9",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: "8px",
                        display: "inline-block",
                      }}
                    >
                      SI Created
                    </span>
                    <span>- SI created for shipment request</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        background: "#898989",
                        textDecoration: "line-through",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: "8px",
                        display: "inline-block",
                      }}
                    >
                      SI CLOSED
                    </span>
                    <span>- An SI is CLOSED for shipment request</span>
                  </div>
                </div>
              </div>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label="Dense padding"
            />
          </Box>
        </>
      )}
    </div>
  );
}
